export class PermissionError extends Error {
  public readonly code: string = 'PERMISSION_DENIED';
  public readonly permission: string;
  public readonly userId?: string;

  constructor(permission: string, userId?: string, message?: string) {
    const defaultMessage = `Access denied: Missing permission '${permission}'${userId ? ` for user ${userId}` : ''}`;
    super(message || defaultMessage);
    this.name = 'PermissionError';
    this.permission = permission;
    this.userId = userId;
  }
}